/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs */

const en_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screening and AI disclosure`)
};

const ar_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفحص والإفصاح عن الذكاء الاصطناعي`)
};

const bn_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ক্রিনিং ও এআই ঘোষণা`)
};

const de_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfung und KI-Kennzeichnung`)
};

const es_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrado y declaración de IA`)
};

const fr_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrage et mention IA`)
};

const pt_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtragem e declaração de IA`)
};

const zh_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审查与 AI 声明`)
};

const tr_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarama ve YZ bildirimi`)
};

const ru_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка и маркировка ИИ`)
};

const pl_svc_ai_image_pod_automation_comply_title6 = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weryfikacja i oznaczenie AI`)
};

/**
* | output |
* | --- |
* | "Screening and AI disclosure" |
*
* @param {Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_comply_title6 = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Comply_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_comply_title6(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_comply_title6(inputs)
	return en_svc_ai_image_pod_automation_comply_title6(inputs)
});
export { svc_ai_image_pod_automation_comply_title6 as "svc_ai-image-pod-automation_COMPLY_title" }